import { createSlice, createAction } from '@reduxjs/toolkit'
import { HubConnectionState } from '@microsoft/signalr'
import { formatISO } from 'date-fns'

const initialSignalr = {
    state: HubConnectionState.Disconnected,
    error: null,
}
const initialState = {
    connection: initialSignalr,
    peers: [],
    groups: [],
    messages: [],
    updates: [],
    mapupdates: [],
}

const signalrSlice = createSlice({
    name: "signalr",
    initialState,
    reducers: {
        setConState(state, action) {
            state.connection = action.payload
        },
        setPeers(state, action) {
            state.peers = action.payload
            state.peers.splice(0, 0, {id: -1, name: 'Server'})
        },
        addGroup(state, action) {
            const idx = state.groups.findIndex(f => f === action.payload)
            if (idx === -1) {
                state.groups.push(action.payload)
            }
        },
        removeGroup(state, action) {
            const idx = state.groups.findIndex(f => f === action.payload)
            if (idx !== -1) {
                state.groups.splice(idx, 1)
            }
        },
        removeMapUpdate(state, action) {
            const idx = state.mapupdates.findIndex(f => f.id === action.payload)
            if (idx !== -1) {
                state.mapupdates.splice(idx, 1)
            }
        },
        removeMapUpdates(state, action) {
            action.payload.forEach(i => {
                const idx = state.mapupdates.findIndex(f => f.id === i)
                if (idx !== -1) {
                    state.mapupdates.splice(idx, 1)
                }
            })
        },
        removeTaskUpdate(state, action) {
            const idx = state.updates.findIndex(f => f.taskName === action.payload)
            if (idx !== -1) {
                state.updates.splice(idx, 1)
            }
        },
        removeMessage(state, action) {
            const idx = state.messages.findIndex(f => f.id === action.payload)
            if (idx !== -1) {
                state.messages.splice(idx, 1)
            }
        },
        openNew(state, action) {
            const idx = state.messages.findIndex(f => f.id === action.payload.id)
            if (idx === -1) {
                state.messages.push({
                    id: action.payload.id,
                    name: action.payload.name,
                    msg: []
                })
            }
        },
        sentMessage(state, action) {
            const idx = state.messages.findIndex(f => f.id === action.payload.id)
            if (idx !== -1) {
                state.messages[idx].msg.splice(0, 0, action.payload.message)
            }
        },
        receivedMessage(state, action) {
            const idx = state.messages.findIndex(f => f.id === action.payload.id)
            if (idx === -1) {
                state.messages.push(
                {
                    id: action.payload.id,
                    name: action.payload.name,
                    msg: [{
                        author: { id: action.payload.id, name: action.payload.name },
                        text: action.payload.message,
                        timestamp: new Date(),
                    }]
                })
            } else {
                state.messages[idx].msg.splice(0, 0, {
                    author: { id: action.payload.id, name: action.payload.name },
                    text: action.payload.message,
                    timestamp: new Date(),
                })
            }
        },
        receivedTaskUpdate(state, action) {
            const upd = state.updates.find(f => f.taskName === action.payload.taskName)
            if (upd) {
                upd.count = action.payload.count
                upd.total = action.payload.total
            } else {
                state.updates.push(action.payload)
            }
        },
        receivedMapUpdate(state, action) {
            const idx = state.mapupdates.findIndex(f => f.id === action.payload.id)
            if (idx !== -1) {
                state.mapupdates.splice(idx, 1)
            }
            state.mapupdates.push(action.payload)
        }
    }
})

export const {
    setConState,
    setPeers,
    addGroup,
    removeGroup,
    openNew,
    sentMessage,
    receivedMessage,
    receivedTaskUpdate,
    receivedMapUpdate,
    removeMessage,
    removeTaskUpdate,
    removeMapUpdate,
    removeMapUpdates,
} = signalrSlice.actions

export const signalrCon = (state) => state.signalr.connection
export const taskUpdates = (state) => state.signalr.updates
export const mapUpdates = (state) => state.signalr.mapupdates
export const userMessages = (state) => state.signalr.messages
export const signalrPeers = (state) => state.signalr.peers

export default signalrSlice.reducer
